import React from "react";
import { CharacterSheet, RaizEspiritual } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const RaizesEspirituais: React.FC<Props> = ({ character, onChange }) => {
  const addRaiz = () => {
    onChange({
      ...character,
      raizesEspirituais: [
        ...character.raizesEspirituais,
        { nome: "", nivel: 1, elemento: "", bonus: 0, custo: 0 },
      ],
    });
  };

  const removeRaiz = (index: number) => {
    onChange({
      ...character,
      raizesEspirituais: character.raizesEspirituais.filter((_, i) => i !== index),
    });
  };

  const updateRaiz = (index: number, field: keyof RaizEspiritual, value: any) => {
    const newRaizes = [...character.raizesEspirituais];
    newRaizes[index] = { ...newRaizes[index], [field]: value };
    onChange({ ...character, raizesEspirituais: newRaizes });
  };

  return (
    <div className="section">
      <h2>Raízes Espirituais</h2>
      <button type="button" onClick={addRaiz} className="btn-add">
        + Adicionar Raiz Espiritual
      </button>
      {character.raizesEspirituais.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Raiz Espiritual</th>
              <th>Nível</th>
              <th>Elemento</th>
              <th>Bônus</th>
              <th>Custo</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {character.raizesEspirituais.map((raiz, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    value={raiz.nome}
                    onChange={(e) => updateRaiz(index, "nome", e.target.value)}
                    placeholder="Nome da raiz"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={raiz.nivel}
                    onChange={(e) => updateRaiz(index, "nivel", parseInt(e.target.value) || 1)}
                    min="1"
                    max="5"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={raiz.elemento}
                    onChange={(e) => updateRaiz(index, "elemento", e.target.value)}
                    placeholder="Ex: Fogo"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={raiz.bonus}
                    onChange={(e) => updateRaiz(index, "bonus", parseInt(e.target.value) || 0)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={raiz.custo}
                    onChange={(e) => updateRaiz(index, "custo", parseInt(e.target.value) || 0)}
                    min="0"
                  />
                </td>
                <td>
                  <button type="button" onClick={() => removeRaiz(index)} className="btn-remove">
                    Remover
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
